import { render, staticRenderFns } from "./SuppliersSender.vue?vue&type=template&id=51b96da5&scoped=true&"
import script from "./SuppliersSender.vue?vue&type=script&lang=js&"
export * from "./SuppliersSender.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersSender.vue?vue&type=style&index=0&id=51b96da5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b96da5",
  null
  
)

export default component.exports